module.exports = __webpack_public_path__ + "img/pic_create.df54e2b0.png";